Intl = require 'intl'
Intl.__addLocaleData require('intl-locale-data')
